export default {
  /**
   * @param {Object} state
   * @returns {boolean}
   */
  isScrollDisabled: (state) => state.scrollLockLevel > 0,
}
